import { GraphhopperAddress } from "./graphhopper-address";

export class GraphhopperCustomer {
  
  id        : string;
  quantity  : number;
  address : GraphhopperAddress = new GraphhopperAddress();

}

